import { Route, Routes } from 'react-router';
import DashboardPage from '../pages/Dashboard';
import PhysicalResultPage from '../pages/PhysicalResultPage';
import TraineeAssessmentPage from '../pages/TraineeAssessment';
import TraineeTrainingPage from '../pages/TraineeTraining';
import RedirectTo from '@/RedirectTo';
import { ModuleSubCategory } from '@/apolloClient.types';
import Locked from '@/components/blocks/Locked';
import NotFound from '@/components/blocks/NotFound';
import AuthenticatedLayout from '@/components/layouts/AuthenticatedLayout';
import AssessmentManagementPage from '@/pages/AssessmentManagementPage';
import AssessmentResultsPage from '@/pages/AssessmentResultsPage';
import CompaniesPage from '@/pages/CompanyManagementPage';
import CourseManagementPage from '@/pages/CourseManagementPage';
import CourseTemplateManagementPage from '@/pages/CourseTemplateManagementPage';
import GlossaryManagementPage from '@/pages/GlossaryManagementPage';
import GroupManagementPage from '@/pages/GroupManagementPage/GroupManagementPage';
import ModuleLauncher from '@/pages/ModuleLauncher/';
import PerformanceResultPage from '@/pages/PerformanceResultsPage/PerformanceResultPage';
import ProfilePage from '@/pages/ProfilePage';
import ProgramManagementPage from '@/pages/ProgramManagementPage/ProgramManagementPage';
import ReportsPage from '@/pages/Reports';
import IndividualReportRoute from '@/pages/Reports/Trainee/IndividualReportRoute';
import SignOutPage from '@/pages/SignOutPage';
import SystemManagementPage from '@/pages/SystemManagementPage';
import TrainingManagementPage from '@/pages/TrainingManagementPage';
import UserManagementPage from '@/pages/UserManagementPage';

const AuthenticatedRoutes = () => (
    <Routes>
        <Route element={<RedirectTo to="/" />} path="/login/*" />
        <Route element={<AuthenticatedLayout isMultiCard />} path="/">
            <Route element={<DashboardPage />} index />
        </Route>
        <Route element={<AuthenticatedLayout />} path="*">
            <Route element={<UserManagementPage />} path="usermanagement/users" />
            <Route element={<GroupManagementPage />} path="usermanagement/groups" />
            <Route element={<ProfilePage />} path="profile" />
            <Route element={<SystemManagementPage />} path="system" />
            <Route element={<CompaniesPage />} path="companies" />
            <Route element={<CourseTemplateManagementPage />} path="programmanagement/templates" />
            <Route element={<CourseManagementPage />} path="programmanagement/courses" />
            <Route element={<ProgramManagementPage />} path="programmanagement/programs" />
            <Route element={<AssessmentManagementPage />} path="contentmanagement/assessments" />
            <Route element={<TrainingManagementPage />} path="contentmanagement/trainings" />
            <Route element={<GlossaryManagementPage />} path="glossary" />
            <Route
                element={<ModuleLauncher />}
                path="content/play/:moduleInstanceId/:assessmentRunId?/:courseInstanceId?/*"
            />
            <Route element={<PhysicalResultPage />} path="results/physiological/:assessmentRunId?" />
            <Route
                element={
                    <AssessmentResultsPage
                        subCategory={ModuleSubCategory.Cognitive}
                        key={ModuleSubCategory.Cognitive}
                    />
                }
                path="results/cognitive/:assessmentRunId?"
            />
            <Route
                element={
                    <AssessmentResultsPage
                        subCategory={ModuleSubCategory.Psychological}
                        key={ModuleSubCategory.Psychological}
                    />
                }
                path="results/psychological/:assessmentRunId?"
            />
            <Route element={<PerformanceResultPage />} path="results/performance" />
            <Route element={<TraineeAssessmentPage />} path="content/assessments/:assessmentRunId?/:subCategory?" />
            <Route element={<TraineeTrainingPage />} path="content/trainings" />
            <Route element={<IndividualReportRoute />} path="reports/individual/:assessmentRunId/:userId/:programId?" />
            <Route element={<ReportsPage />} path="reports/individual" />
            <Route element={<SignOutPage />} path="signout" />
            <Route element={<Locked />} path="locked/*" />
            <Route element={<NotFound homePath="/" />} path="*" />
        </Route>
    </Routes>
);

export default AuthenticatedRoutes;
